export default {
  name: 'DialogResponse',

  data: () => ({
    localModal: {
      showModal: false,
      status: '',
      title: '',
      time: 0,
    },
    success: false,
    error: false,
    warn: false,
    time: 1500,
  }),

  props: {
    ModalResponse: {
      type: Object,
      default: () => ({}),
    },
  },

  watch: {
    ModalResponse: {
      handler(value) {
        if (value?.showModal) {
          this.localModal = { ...value }
          this.time = value.time || this.time
          if (value.status === 'success') {
            this.success = true
            this.localModal.status = 'blueSpace'
            this.localModal.icon = 'mdi-check-circle'
          } else if (value.status === 'warn') {
            this.warn = true
            this.localModal.status = 'orange'
            this.localModal.icon = 'mdi-information-variant-circle'
          } else if (value.status === 'error') {
            this.error = true
            this.localModal.status = 'red'
            this.localModal.icon = 'mdi-alert-decagram'
          }
          this.closeDialog()
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    resetFlags() {
      this.success = false
      this.warn = false
      this.error = false
      this.localModal = {
        showModal: false,
        status: '',
        title: '',
        time: 0,
      }
    },

    closeDialog() {
      setTimeout(() => {
        this.resetFlags()
      }, this.time)
    },
  },
}
